import { render, staticRenderFns } from "./MainLayout2.vue?vue&type=template&id=78f2cafb"
import script from "./MainLayout2.vue?vue&type=script&lang=js"
export * from "./MainLayout2.vue?vue&type=script&lang=js"
import style0 from "./MainLayout2.vue?vue&type=style&index=0&id=78f2cafb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports